import { useSyncExternalStore } from "react";

const names = new Map<string, string>();
const listeners = new Set<() => void>();

export const rememberPageEntityName = (id: string, name: string) => {
  if (names.get(id) === name) return;
  names.set(id, name);
  listeners.forEach((listener) => listener());
};

export const pageEntityName = (id: string): string | undefined => names.get(id);

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const usePageEntityName = (id: string | undefined): string | undefined =>
  useSyncExternalStore(subscribe, () => (id ? names.get(id) : undefined));

export const forgetPageEntityNames = () => names.clear();

export type WizardStepField = { label: string; paths: readonly string[] };

export type WizardStepLayout = { key: string; label: string; fields: readonly WizardStepField[] };

export type WizardStep = { key: string; label: string; steps?: readonly WizardStepLayout[] };

const wizardSteps = new Map<string, WizardStep>();

export const rememberWizardStep = (eventId: string, step: WizardStep) => {
  const known = wizardSteps.get(eventId);
  if (known && JSON.stringify(known) === JSON.stringify(step)) return;
  wizardSteps.set(eventId, step);
  listeners.forEach((listener) => listener());
};

export const wizardStep = (eventId: string): WizardStep | undefined => wizardSteps.get(eventId);

export const useWizardStep = (eventId: string | undefined): WizardStep | undefined =>
  useSyncExternalStore(subscribe, () => (eventId ? wizardSteps.get(eventId) : undefined));

export const forgetWizardSteps = () => wizardSteps.clear();

export type ShownCreationArea = { label: string; status: string; remaining: boolean };

let creationProgressShown: ShownCreationArea[] | undefined;

export const rememberCreationProgress = (areas: ShownCreationArea[] | undefined) => {
  creationProgressShown = areas;
};

export const creationProgressNow = (): ShownCreationArea[] | undefined => creationProgressShown;

let creationProgressRefresh: (() => Promise<void>) | undefined;

export const rememberCreationProgressRefresh = (refresh: (() => Promise<void>) | undefined) => {
  creationProgressRefresh = refresh;
};

export const refreshCreationProgress = async (): Promise<void> => {
  await creationProgressRefresh?.();
};
